<template>
  <div>
    <el-select v-model="selectList" :placeholder="placeholder" 
      multiple collapse-tags 
      size="small"
      @change="changeSelect"
      clearable
      :style="{width: setwidth + 'px'}"
      >
      <el-option v-if="selectedList.length > 0" key="全选" label="全选" value="全选" />
      <div>
        <div v-if="placeholder === '请选择区域'">
          <el-option v-for="item of selectedList" :key="item" :label="provname[ item - 1 ]" :value="item" />
        </div>
        <div v-else-if="placeholder === '请选择时间'">
          <el-option v-for="item of selectedList" :key="item" :label="item" :value="item" />
        </div>
        </div>
    </el-select>
  </div>
</template>

<script>
import { provname } from '@/tableworks/admin';
export default {
  name: 'HlSelect',
  data(){
    return {
      checked: false,
      selectList: [],
      provname,
      selectStates: 0,
    }
  },
  computed: {
    setwidth() {
      if (this.placeholder==='请选择时间' && this.selectedList.length > 1) {
        if (this.selectedList[1].includes('.zip')) {
          return 300
        } else {
          return 210
        }
      } else {
        return 210
      }
    }
  },
  props:{
    selectedList: {
      type: Array,
      required: true
    },
    
    placeholder: {
      type: String,
      required: true
    }
  },
  watch:{
    selectList: {
      deep: true,
      handler(val) {
        this.$emit('selectList',val)
      }
    },
    selectedList: {
      deep: true,
      handler(val) {
        this.selectList = []
      }
    }
  },
  methods:{
    changeSelect(val) {
      if (val.includes('全选') && this.selectStates === 0) {
        this.selectList = this.selectAll()
        this.selectStates = 1
        return false
      }
      if (val.includes('全选') && (val.length - 1) < this.selectedList.length) {
        this.selectList = this.selectList.filter(item => {
          return item !== '全选'
        })
        this.selectStates = 0
        return false
      }
      if (!val.includes('全选') && (val.length === this.selectedList.length) && this.selectStates === 0 ) {
        this.selectList.unshift('全选')
        this.selectStates = 1
        return false
      }
      if (this.selectStates === 1) {
        this.selectList = [];
        this.selectStates = 0;
        return false
      } else {
        this.selectList = val
      }
    },
    selectAll() {
      let selectAllData = []
      this.selectedList.map(ele => selectAllData.push(ele))
      selectAllData.unshift('全选')
      return selectAllData
    },
  },

}
</script>


// WEBPACK FOOTER //
// src/components/HlSelect/index.vue